"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHooks = void 0;
const asyncHooksInterface_1 = require("./asyncHooksInterface");
const createHooks = (defaultHooks) => {
    let currentHooks = {};
    const hooks = {};
    for (const key in defaultHooks) {
        const f = ((...args) => {
            var _a;
            const hooks = currentHooks === defaultHooks ? (_a = asyncHooksInterface_1.asyncHooks === null || asyncHooksInterface_1.asyncHooks === void 0 ? void 0 : asyncHooksInterface_1.asyncHooks.get()) !== null && _a !== void 0 ? _a : defaultHooks : currentHooks;
            let handler = hooks[key];
            // tslint:disable-next-line: strict-type-predicates
            if (typeof handler !== 'function') {
                handler = defaultHooks[key];
            }
            return handler(...args);
        });
        hooks[key] = f;
    }
    const run = (f, implementations) => {
        try {
            currentHooks = implementations || defaultHooks;
            asyncHooksInterface_1.asyncHooks === null || asyncHooksInterface_1.asyncHooks === void 0 ? void 0 : asyncHooksInterface_1.asyncHooks.set(currentHooks);
            return f();
        }
        finally {
            currentHooks = defaultHooks;
        }
    };
    return { run, hooks };
};
exports.createHooks = createHooks;
//# sourceMappingURL=hook.js.map